/** Player web embebido Radio Visual / tnovideo1 (misma señal que tnonetwork.com). */
export const SRVSTM_IFRAME_PLAYER_SRC =
  'https://playerv.srvstm.com/video/tnovideo1/true/true/false//nao/nao';
